var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconhomeinactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_6149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4932C8.6193 12.4932 7.5 13.6125 7.5 14.9932V19.9932H12.5V14.9932C12.5 13.6125 11.3807 12.4932 10 12.4932Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.9935V19.9935H17.5C18.8807 19.9935 20 18.8742 20 17.4935V9.89271C20.0002 9.45978 19.832 9.04376 19.5308 8.73271L12.4492 1.07685C11.1996 -0.275105 9.09074 -0.358112 7.73879 0.891419C7.67457 0.950794 7.6127 1.01263 7.55336 1.07685L0.48418 8.73021C0.173945 9.04255 -0.000117128 9.46497 5.9134e-08 9.90521V17.4935C5.9134e-08 18.8742 1.1193 19.9935 2.5 19.9935H5.83332V14.9935C5.84891 12.7212 7.68355 10.8656 9.89867 10.8121C12.1879 10.7569 14.1492 12.6441 14.1667 14.9935Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4932C8.6193 12.4932 7.5 13.6125 7.5 14.9932V19.9932H12.5V14.9932C12.5 13.6125 11.3807 12.4932 10 12.4932Z",
    fill: "#D0D5DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_6149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconhomeinactive);
export default __webpack_public_path__ + "static/media/iconhomeinactive.5ed2a80dc7db60422f15fba27e8d355d.svg";
export { ForwardRef as ReactComponent };